import { createTheme } from '@mui/material/styles';

import customBreakpoints from './customBreakpoints';
import customPalette from './customPalette';
import customTypography from './customTypography';
import ComponentOverrides from './overrides/index';

const theme = createTheme({
  breakpoints: customBreakpoints,
  typography: {
    fontFamily: ['Graphik', 'sans-serif'].join(','),
  },
});

theme.typography = {
  ...theme.typography,
  ...customTypography(theme),
};

theme.palette = {
  ...theme.palette,
  ...customPalette(theme),
};

theme.components = ComponentOverrides(theme);

export default theme;
